import { CKBox, CKContainerProps } from 'clearkit';

import { CustomObjectsContainer } from './Container';

export function Root({ children }: CKContainerProps) {
  return (
    <CustomObjectsContainer>
      <CKBox
        className="p-8 text-center text-gray-700 lg:p-12"
        variant="tinted-frame"
      >
        {children}
      </CKBox>
    </CustomObjectsContainer>
  );
}

export function Icon({ children }: CKContainerProps) {
  return (
    <CKBox
      className="items-center justify-center w-10 h-10 mx-auto mb-4 lg:mt-12"
      variant="card"
    >
      {children}
    </CKBox>
  );
}

export function Content({ children }: CKContainerProps) {
  return <div className="mx-auto mb-4 w-[460px] lg:mb-12">{children}</div>;
}

export function Heading({ children }: CKContainerProps) {
  return <h1 className="mb-3 font-medium text-md">{children}</h1>;
}

export function Paragraph({ children }: CKContainerProps) {
  return <p className="mb-6 text-base">{children}</p>;
}
